import { render, staticRenderFns } from "./ApiLookupMappingFormSection.vue?vue&type=template&id=37b26700&scoped=true&"
import script from "./ApiLookupMappingFormSection.vue?vue&type=script&lang=js&"
export * from "./ApiLookupMappingFormSection.vue?vue&type=script&lang=js&"
import style0 from "./ApiLookupMappingFormSection.vue?vue&type=style&index=0&id=37b26700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b26700",
  null
  
)

export default component.exports